//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

export enum THRESHOLD_FAILED_CONFIRMATION_MODAL_ACTIONS {
  OPEN_MODAL = 'THRESHOLD_FAILED_CONFIRMATION_MODAL_ACTIONS/OPEN_MODAL',
  CLOSE_MODAL = 'THRESHOLD_FAILED_CONFIRMATION_MODAL_ACTIONS/CLOSE_MODAL',
}
